import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import moment from 'moment';
import { useSelector } from 'react-redux';
import Link from 'next/link';
import { flagsmith } from '@common/Lib/Flagsmith';
import { getImageUrlWithSize } from '@common/Utility/common-utils';
import RightSideBar from '../RightSideBar/RightSideBar';
import {
  IC_COD_DARK_GREY,
  IC_EXPRESS_NEW,
  IC_CALL_DARK_GREEN,
  IC_TIMER,
  IC_USER,
  IC_WHATSAPP,
  IMG_THANKS,
  IC_PHONE_GREEN,
  IC_PAY_APPLE,
  IC_ORDERS_CREDIT_CARD,
  IC_STORE,
  PRODUCT_CARD_DEFAULT,
  LOGO_ASTER_SECURE,
  IC_FLASH,
  IC_EXPRESS_SHEDULED,
  IC_RX_MANDALAY,
} from '@common/Assets/images';
import VerificationStatus from '../VerificationStatus/VerificationStatus';
import CommonSpaceHolder from '../CommonSpaceHolder/CommonSpaceHolder';
import { OrderTrackPopUpStyled } from './OrderTrackPopUpStyled';
import StatusCard from '../StatusCard/StatusCard';
import {
  ONLINE_PHARMACY_ROUTE,
  PAYMENT_METHOD_ANALYTICS_VALUE,
  PAYMENT_METHODS,
  ERX_CONSTANTS,
  SCREEN_NAME,
  DELIVERY_METHOD,
  ORDER_STATUSES,
  FLAGSMITH_KEYS,
} from '@common/Utility/constants';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const OrderTrackPopUp = (props) => {
  const router = useRouter();
  const generateURL = useNavigationURL();
  const flashDeliveryFlag = flagsmith.getValue(FLAGSMITH_KEYS.FLASH_DELIVERY, { json: true });
  const { orderDetails, trackInfo, orderType, isSheduledExpress } = props;
  const { deliveryDetails, payments, runOrderId, count, totalProducts, deliveryMethod, id } = orderDetails;
  const { trackingDetails } = trackInfo;

  const outForDeliveryObj = trackInfo?.orderStatus?.find((item) => item?.title === 'Out for Delivery');
  const rawDate = outForDeliveryObj?.rawDate;
  let isOutForDelivery = outForDeliveryObj?.status;
  const isDelivered = props?.trackInfo?.orderStatus?.find((item) => item?.title === 'Delivered');
  const userData = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource);
  const fallBackDateTime = `${orderDetails?.formattedDate}-${orderDetails?.formattedTime}`;
  
  if (isDelivered?.status) {
    isOutForDelivery = false;
  }
  const today = new Date();
  const currentTime = moment(today);
  const expectDeliveryTime = moment(rawDate);
  const duration = moment.duration(expectDeliveryTime.diff(currentTime));
  const timeLeft = duration.minutes();

  const timeConst = trackingDetails?.deliveryEta;
  const [time, setTime] = useState(Math.floor(timeConst / 60) || timeLeft);

  const paymentOrderNaming = (item) => {
    if (item?.method?.toUpperCase() === PAYMENT_METHODS.CASH || item?.method?.toUpperCase() === PAYMENT_METHODS.COD) {
      return 'Cash On Delivery';
    }
    if (item?.method?.toUpperCase() === 'CARD' || item?.method?.toUpperCase() === 'NEW_CARD') {
      return 'Paid via Credit/Debit Card';
    }
    if (item?.method?.toUpperCase() === 'SAVED_CARD') {
      return 'Paid via Saved Card';
    }
    if (item?.method?.toUpperCase() === 'APPLEPAY') {
      return 'Paid via Apple Pay';
    }
    return 'Paid via Aster Secure Points';
  };

  const getPaymentOptionUrl = (method) => {
    if (method?.toUpperCase() === PAYMENT_METHODS.CASH || method?.toUpperCase() === PAYMENT_METHODS.COD) {
      return IC_COD_DARK_GREY.src;
    }
    if (method?.toUpperCase() === 'CARD' || method?.toUpperCase() === 'NEW_CARD') {
      return IC_ORDERS_CREDIT_CARD.src;
    }
    if (method?.toUpperCase() === 'APPLEPAY') {
      return IC_PAY_APPLE.src;
    }
    return PRODUCT_CARD_DEFAULT.src;
  };

  const getProgressClassName = (item) => {
    if (item?.status) return 'active';
    if (!props?.isIdPresent && item?.title === 'Order Placed') return 'active';
    return 'dotted-border';
  };

  useEffect(() => {
    const myInterval = setInterval(() => {
      if (time > 0) {
        setTime((sec) => sec - 1);
      }
      if (time === 0) {
        clearInterval(myInterval);
      }
    }, 30000);
    return () => {
      clearInterval(myInterval);
    };
  }, [time]);

  const validatePayments = (payment) => {
    let isValid = true;
    if(payment && Object.keys(payment).length === 0) isValid = false;
    if(payment && payment["currency"] === "" || payment && payment["method"] === "") {
      isValid = false;
    }
    if(payment && payment["amount"] === (undefined || null) || payment && payment["copay"] === (undefined || null)) {
      isValid = false;
    }

    return isValid;
  }; 

  const getPharmacyDetails = (orderDetails) => (
    <div className="d-flex flex-column mt-4">
      <div className="font-bold mb-2">Pharmacy</div>
      <div className="pharmacyContainer">
        <div className="d-flex align-items-center pharmacyDetails">
          <Image src={IC_STORE} width={32} height={32} alt="pharmacyIcon" />
          <div className="pharmacyText">{orderDetails?.pharmacyDetails?.address}</div>
        </div>
        <div className="pharmacyContact">
          <div className="d-flex align-items-center">
            <Image src={IC_CALL_DARK_GREEN} width={30} height={30} alt="phoneNumber" />
            <div className="extra-padding">{orderDetails?.pharmacyDetails?.phoneNumber}</div>
          </div>
          <div className="d-flex align-items-center m-2">
            <Link passHref href={`https://wa.me/${orderDetails?.pharmacyDetails?.whatsappNumber}`}>
            <a target="_blank">
              <Image src={IC_WHATSAPP} width={30} height={30} alt="phoneNumber" />
              <div className="extra-padding">Whatsapp</div>
            </a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );

  const getPaymentDetails = (title, currency, amount, showIcon = false) => (
    <div className="d-flex justify-content-between">
      <div className="d-flex padding-left">
        <div className="pd-2">{showIcon && <Image src={IC_COD_DARK_GREY} alt="cod" />}</div>
        <div className="font-16">{title === 'cash' ? 'Cash on Delivery': title}</div>
      </div>
      <div className="d-flex padding-right">
        <div className="font-bold">{currency}</div>
        <div className="padding-sm font-bold">{amount}</div>
      </div>
    </div>
  );

  const getStatus = () => {
    if (outForDeliveryObj?.status || isDelivered?.status) {
      return 'verified-wo-image';
    }
    return 'process';
  };

  const showViewDetailsCTA = router?.asPath?.indexOf('myorders') < 0 || orderType === ERX_CONSTANTS.PRESCRIPTION;

  const getTitle = () => {
    if (outForDeliveryObj?.status && !isDelivered?.status) {
      return ORDER_STATUSES.OUT_FOR_DELIVERY;
    }
    if (isDelivered?.status) {
      return ORDER_STATUSES.DELIVERED;
    }
    if(orderDetails?.status === ORDER_STATUSES.SCHEDULED) {
      return ORDER_STATUSES.SCHEDULED;
    }
    return ORDER_STATUSES.PROCESSING;
  };
  const getOrderTime = (OrderDeliveredTime) => {
    if (OrderDeliveredTime) {
      return `The delivery partner reached your location at ${OrderDeliveredTime?.split('-')?.[1]?.toLowerCase()}`;
    }
    return 'The delivery partner reached your location';
  };

  const showMap = orderDetails?.deliveryMethod === DELIVERY_METHOD.EXPRESS || orderDetails?.deliveryMethod === DELIVERY_METHOD.FLASH || orderDetails?.deliveryMethod === DELIVERY_METHOD.STANDARD;

  return (
    <RightSideBar
      modalTitle="Track Shipment"
      bodyBg={false}
      size="md"
      footerBtnFullWidth
      closeButton
      customClass="orderTrackPopUp"
      primaryButtonText={showViewDetailsCTA && 'View Order Details'}
      primaryButtonClicked={() => {
        if (orderDetails?.orderNumber) {
          router.push({ 
            pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/myorders/${orderDetails?.orderNumber}`),
            query: {
              isRxOrder: true,
              isFlash: false,
            },
          });
        } else if (orderType === 'Shipment') {
          router.push({ pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/myorders/${orderDetails?.runOrderId || orderDetails?.id}`) });
        }
      }}
      formattedDate={orderDetails?.formattedDate}
      formattedTime={orderDetails?.formattedTime}
      deliveryTitle={orderDetails?.deliveryTitle}
      appVariant="epharmacy"
      footerEnable={(orderDetails?.orderNumber || (orderDetails?.id && orderType === ERX_CONSTANTS?.SHIPMENT )) && router?.asPath?.indexOf('myorders') < 0 || false}
      orderType={orderType}
      handleClose={() => props?.close()}
    >
      {orderType !== ERX_CONSTANTS.PRESCRIPTION && isDelivered?.status && (
        <>
          <CommonSpaceHolder
            outerCustomClass="spaceHolder"
            icon={IMG_THANKS}
            title="Order Delivered Successfully!"
            subtitle={getOrderTime(isDelivered?.formattedDate)}
          />
          <div className="orderSucessfull" />
        </>
      )}
      {orderType !== ERX_CONSTANTS.PRESCRIPTION && showMap && isOutForDelivery && (
        <CommonSpaceHolder outerCustomClass="showMap" showIcon={false}>
          {/* {slotETA && 
          <div className="deliveryStatus">Delivery in &nbsp; <span className="deliveryMin">{slotETA}</span></div>} */}
          {trackingDetails?.deliveryEtaMessage && (
            <div className="deliveryStatus">
              <div className="timer">
                <Image src={IC_TIMER.src} width={18} height={18} />
              </div>
              <span className="deliveryMin">{trackingDetails?.deliveryEtaMessage}</span>
            </div>
          )}
          <div>
            <iframe
              src={trackingDetails?.mapUrl}
              width="400"
              height="520"
              style={{ border: 0 }}
              loading="eager"
              id="iframe"
              title="map"
            />
          </div>
        </CommonSpaceHolder>
      )}
      <OrderTrackPopUpStyled>
        <div className={isOutForDelivery ? 'orderTrackDetails pt-0' : 'orderTrackDetails'}>
          {orderType === ERX_CONSTANTS.PRESCRIPTION ? (
            <div className="patientDetails">
              <div className="patientImage">
                <Image src={getImageUrlWithSize(userData?.photo?.[0]?.url, 44, 44) || IC_USER?.src} width={44} height={44} unoptimized/>
              </div>
              <div className="patientInitals">
                <div>Patient Name</div>
                <div>{orderDetails?.patientName}</div>
              </div>
              {orderDetails?.orderNumber && (
              <div className="pomBadge">
              <Image src={IC_RX_MANDALAY.src} width={22} height={22} alt="POM Badge" />
              </div>
              )}
            </div>
          ) : (
            <div className={showMap && isOutForDelivery ? 'trackPkgHeader pt-0' : 'trackPkgHeader'}>
              <div className="orderIdDetails">
                <span>Order Id {id || runOrderId}</span>
                <p>
                  {' '}
                  {count || totalProducts} {(count || totalProducts) > 1 ? 'items' : 'item'}
                </p>
              </div>
              <div className="deliveryStatusDetails">
                <div className="deliveryTitle">
                  <VerificationStatus classStatus="status" label={getTitle()} status={getStatus()} withoutIcon />
                </div>
                {flashDeliveryFlag?.enabled && deliveryMethod === DELIVERY_METHOD.FLASH && (
                  <div className="express">
                    <Image src={IC_FLASH} width={50} height={22} />
                  </div>
                )}
                 {(deliveryMethod === DELIVERY_METHOD.EXPRESS || orderDetails?.status === SCREEN_NAME?.SCHEDULED_EXPRESS || orderDetails?.isScheduled ) && (
                  <div className="express">
                    <Image src={((orderDetails?.isScheduled || orderDetails?.status === SCREEN_NAME?.SCHEDULED_EXPRESS) && isSheduledExpress) ? IC_EXPRESS_SHEDULED : IC_EXPRESS_NEW} width={79} height={22} />
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="trackPkgDeliveryAddress">
            <div className="addressWrapper">
              <span>Delivery Address</span>
              {deliveryDetails?.addressType && <div>{deliveryDetails?.addressType}</div>}
            </div>
            <p>{deliveryDetails?.address}</p>
          </div>
          {orderType === ERX_CONSTANTS.PRESCRIPTION ? (
            <div style={{ padding: '16px' }}>
              <StatusCard statusData={orderDetails} />
              {
                orderDetails?.pharmacyDetails &&
                orderDetails?.pharmacyDetails?.address &&
                getPharmacyDetails(orderDetails)}
                <div>
                  {orderDetails?.payments?.length > 0 &&
                    validatePayments(orderDetails?.payments && orderDetails?.payments?.[0]) && (
                      <div className="paymentDetails mt-4">
                        <div className="mb-3">
                          <div className="font-bold mb-2">Payment Details</div>
                          <div className="paymentDetailsInner">
                            {getPaymentDetails(
                              orderDetails?.payments?.[0].method,
                              orderDetails?.payments?.[0].currency,
                              orderDetails?.payments?.[0].amount,
                              true,
                            )}
                          </div>
                        </div>
                        <div>
                          <div className="font-bold mb-2">Order Summary</div>
                          <div className="paymentDetailsInner">
                            {getPaymentDetails(
                              'Order Value',
                              'AED',
                              orderDetails?.payments?.[0].amount,
                              false,
                              'removeBorder',
                            )}
                            <div className="hr-line"></div>
                            {getPaymentDetails(
                              'Co Pay',
                              'AED',
                              orderDetails?.payments?.[0].copay,
                              false,
                              'removeBorder',
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                </div>
            </div>
          ) : showMap && (isDelivered?.status || isOutForDelivery) ? (
            <div>
              {payments &&
                payments.length > 0 &&
                payments.map((item) => (
                  <div className="payment-section" key={item?.method}>
                    <div className="d-flex justify-content-between">
                      <div className="d-flex align-items-center">
                        {item?.method && (
                          <>
                            <div className="d-flex me-2">
                              {item?.method !== PAYMENT_METHODS?.LOYALTY && (
                                <Image
                                  src={getPaymentOptionUrl(item?.method)}
                                  alt="Cash On Delivery"
                                  width="27px"
                                  height="14px"
                                />
                              )}
                            </div>
                            <div className="payment-label ">{item?.paymentDisplayText}</div>
                          </>
                        )}
                      </div>
                      <div className="payment-money-label">{`AED ${item?.amount}`}</div>
                    </div>
                    {item?.method === PAYMENT_METHODS?.LOYALTY && (
                      <div className="secureImage">
                        <Image src={LOGO_ASTER_SECURE.src} alt="Loyalty" width="87px" height="27px" />
                      </div>
                    )}
                  </div>
                ))}
              <div className="deliveryDetails">
                <div className="deliveryPersonDetails">
                  {trackingDetails?.employeeName && (
                    <div className="deliveryBy">
                      <div className="text">Delivery By</div>
                      <div className="name">{trackingDetails?.employeeName}</div>
                    </div>
                  )}
                </div>
                {trackingDetails?.employeeContact && (
                  <div className="phone">
                    <div className="phoneIcon">
                      <Image src={IC_PHONE_GREEN} width={28} height={28} />{' '}
                    </div>
                    <div className="number">{trackingDetails?.employeeContact}</div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            !isDelivered?.status && (
              <div className="orderSteps">
                <ul className="progressbar">
                  {props?.trackInfo?.orderStatus?.map((item) => (
                    <li className={getProgressClassName(item)} key={item?.title}>
                      <p>
                        {item?.title}
                        <span>{item?.formattedDate || (item?.title === 'Order Placed' && fallBackDateTime)}</span>
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            )
          )}
        </div>
      </OrderTrackPopUpStyled>
    </RightSideBar>
  );
};

OrderTrackPopUp.propTypes = {
  trackInfo: PropTypes.object,
  close: PropTypes.func,
  orderDetails: PropTypes.object,
  isIdPresent: PropTypes.bool,
  orderType: PropTypes.string,
};

OrderTrackPopUp.defaultProps = {
  trackInfo: {},
  close: () => {},
  orderDetails: {},
  isIdPresent: false,
  orderType: '',
};

export default OrderTrackPopUp;
